import { Switch, Form, Input } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useTranslation } from 'react-i18next';


const HeaderForm = ({ formValues, form }) => {
    const { t } = useTranslation();

    // const handleHeaderForm = (checked, resetField) => {
    //     if(!checked) {
    //         form.setFieldValue(resetField, "")
    //     }
    // }
    
    return (
        <>
            <Form.Item name="label" label={t('Label')}>
                <Input />
            </Form.Item>
            <Form.Item name="secondaryText" label={t('Secondary Text')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            {
                formValues && formValues.secondaryText &&
                <Form.Item label="" name="description">
                    <TextArea rows={2} />
                </Form.Item>
            }
            <Form.Item name="info" label={t('Info')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
            {
                formValues && formValues.info &&
                <Form.Item label="" name="formInfo">
                    <TextArea rows={2} autoSize={false} />
                </Form.Item>
            }
             <Form.Item name="hideHeader" label={t('Hide Header')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>

            <Form.Item name="hideInitially" label={t('Hide Initially')} className="horizontal-form-item">
                <Switch size="small" />
            </Form.Item>
        </>
    )
}

export default HeaderForm